module.exports = __webpack_public_path__ + "static/media/6COPUOS4.f59a50b5.jpg";